import { CourseProgressDetails } from '../models/course-progress-details';

export class CourseListResponse {

	courses: {[key: number]: CourseProgressDetails};

}
